import * as Yup from "yup";

export const maintenanceRequestValidationSchema = Yup.object().shape({
  category: Yup.string().required("Category is required"),
  description: Yup.string()
    .required("Description is required")
    .min(10, "Description must be at least 10 characters"),
  urgency: Yup.string().required("Urgency level is required"),
  media: Yup.array().nullable(),
});
